module.exports = __webpack_public_path__ + "img/horizontal_7_3_9016.8eb8a2b5.png";